import { Alert } from '../../common/Alert';
import { onError } from '@apollo/client/link/error';
import { ErrorException } from '../../interfaceTypes';
import {
  UNAUTHORIZED,
  TOKEN_INVALID,
  TOKEN_NOT_FOUND,
  UNAUTHENTICATED,
  REQUEST_NOT_FOUND,
  CONFLICT_EXCEPTION,
  INVALID_AUTH_TOKEN,
  NOT_FOUND_EXCEPTION,
  PRECONDITION_FAILED_EXCEPTION,
  INVALID_OR_EXPIRED_TOKEN_MESSAGE} from '../../constants';

export const errorLink = onError(({ graphQLErrors, networkError, forward, operation }) => {
  if (graphQLErrors && graphQLErrors.length > 0) {
    graphQLErrors.map(({ extensions }) => {
      if (extensions) {
        const { exception, code } = extensions;

        if (code === UNAUTHENTICATED) return forward(operation);

        if (exception) {
          const { response } = exception as ErrorException;

          if (response) {
            const { error, response: errorResponse } = response;

            if (error && error !== REQUEST_NOT_FOUND && error !== NOT_FOUND_EXCEPTION && error !== CONFLICT_EXCEPTION) {
              if (error === TOKEN_NOT_FOUND) {
                Alert.error(INVALID_OR_EXPIRED_TOKEN_MESSAGE);
              } else if (error === INVALID_AUTH_TOKEN) {
                Alert.error("Session expired");
              } else {
                Alert.error(error);
              }
              Alert.error(error);
            }

            if (errorResponse) {
              const { error: responseError, message } = errorResponse;

              if (message && message !== REQUEST_NOT_FOUND && message !== NOT_FOUND_EXCEPTION && message !== CONFLICT_EXCEPTION) {
                Alert.error(message);
              } else if (
                responseError &&
                responseError !== REQUEST_NOT_FOUND &&
                responseError !== NOT_FOUND_EXCEPTION &&
                responseError !== CONFLICT_EXCEPTION &&
                responseError === PRECONDITION_FAILED_EXCEPTION
              ) {
                Alert.error(responseError);
              }
            }
          }
        }
      }
    });

    const [{ message }] = graphQLErrors;

    if (message === UNAUTHORIZED || message === TOKEN_INVALID || message === INVALID_AUTH_TOKEN) return forward(operation);
  }

  if (networkError) Alert.error(networkError.message);
});
